import { Fragment, useState } from 'react';
import { useAsync } from 'react-async';
import { useHistory } from 'react-router';
import { getStates } from '../../../api/services/stateService';
import { ResponseStatus } from '../../../components/notifications';
import { FieldInput } from '../../../components/fieldInput';
import Layout from '../../../components/layout';
import SubmitButton from '../../../components/submitButton';
import { createHomeDistrict } from '../../../api/services/homeDistrictService';

const CreateHomeDistrict = () => {
  const history = useHistory();

  // State
  const [name, setName] = useState('');
  const [visible, setVisible] = useState(false);
  const [stateId, setStateId] = useState<number>(1);
  const [city, setCity] = useState('');
  const [county, setCounty] = useState('');

  //Get the states
  const statesData = useAsync({ promiseFn: getStates });

  /**
   * Saves the home district.
   *
   * @return {Promise<void>} A promise that resolves when the home district is saved.
   */

  const saveHomeDistrict = async () => {
    return await createHomeDistrict({
      name: name,
      isVisible: visible,
      stateId: stateId,
      city: city,
      county: county,
    });
  };

  /**
   * Async hook to save home district
   */
  const save = useAsync({
    deferFn: saveHomeDistrict,
    onResolve: (r) => history.push(`/admin/homeDistricts`, { message: `"${name}" saved successfully!` }),
    onReject: () => window.scrollTo(0, 0),
  });

  /**
   * Handles the submit event.
   *
   * @return {void} No return value.
   */
  const handleSubmit = (): void => save.run();

  return (
    <Fragment>
      <Layout
        isLoading={
          statesData.isPending ||
          save.isPending
        }>
        <Fragment>
          <ResponseStatus state={save} />
          <div>
            <div className='grid grid-cols-6 gap-6 mb-6'>
              <div className='col-span-6 sm:col-span-6'>
                <FieldInput
                  name='district'
                  label='Name'
                  minLength={1}
                  maxLength={150}
                  onChange={(e) => setName(e.target.value)}
                  value={name}
                />
              </div>

              <div className='col-span-6 sm:col-span-6'>
                <FieldInput
                  name='city-field'
                  label='City'
                  onChange={(e) => setCity(e.target.value)}
                  value={city}
                />
              </div>
              <div className='col-span-6 sm:col-span-6'>
                <FieldInput
                  name='county-field'
                  label='County'
                  onChange={(e) => setCounty(e.target.value)}
                  value={county}
                />
              </div>
              <div className='col-span-6 sm:col-span-6'>
                <label className='primary'>
                  State<span className='pl-1 text-red-500'>*</span>
                </label>
                <select
                  onChange={(e) => setStateId(Number(e.target.value))}
                  className='block mt-1 primary'
                  value={stateId}
                >
                  {statesData.data?.data.states.sort((a, b) => {
                    return a.name.localeCompare(b.name);
                  }).map((s) => (
                    <option key={`state_${s.stateId}`} value={s.stateId}>{s.name}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <hr className='py-4' />

          <div className='text-right'>
            <SubmitButton
              text='Save Changes'
              disabled={name.length === 0}
              spinning={save.isPending}
              onClick={handleSubmit}
            />
          </div>
        </Fragment>
      </Layout>
    </Fragment>
  );
};

export default CreateHomeDistrict;
